import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Popover, Svg, Text } from '@hopskipdrive/react-components';
import { ArrowDropDown } from '@mui/icons-material';
import { Stack } from '@mui/material';

import { CloseButton, FilterButton, FilterTypeContainer } from '../FilterPanel.styles';

import { iconMapper } from './StatusFilter.helper';
import { StatusChip } from './StatusFilter.styles';

const statusOptions = [
  {
    label: 'Open',
    value: 'open',
  },
  {
    label: 'Resolved',
    value: 'resolved',
  },
];

export const StatusFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const hasStatus = params.status && statusOptions.some((option) => option.value === params.status);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (status) => {
    const newParams = new URLSearchParams(searchParams);

    if (searchParams.get('page')) {
      newParams.set('page', '1');
    }

    newParams.set('status', status);
    setSearchParams(newParams);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'status-filter-popover' : undefined;

  return (
    <>
      <FilterButton variant="text" open={open} active={Boolean(hasStatus)} onClick={handleOpen}>
        Status
        <ArrowDropDown />
      </FilterButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ '.MuiBackdrop-root': { backgroundColor: 'transparent' } }}
      >
        <FilterTypeContainer>
          <Box className="filter-header">
            <Text variant="body2">Filter by Status</Text>
            <CloseButton onClick={handleClose}>
              <Svg icon="cross" />
            </CloseButton>
          </Box>
          {statusOptions.length && (
            <Stack className="filter-options" spacing={2}>
              {statusOptions.map((option, index) => (
                <StatusChip
                  key={index}
                  className={`status-${option.value}`}
                  icon={<ValueIcon value={option.value} />}
                  label={option.label}
                  variant="outlined"
                  onClick={() => {
                    handleStatusChange(option.value);
                    handleClose();
                  }}
                />
              ))}
            </Stack>
          )}
        </FilterTypeContainer>
      </Popover>
    </>
  );
};

const ValueIcon = ({ value }) => {
  const icon = iconMapper[value];

  if (!icon) {
    return null;
  }

  return icon;
};
